import React, { Component } from 'react';
import {withRouter} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import {actionCreators} from "../../../store/LocationDetail";

class WorkOrdersTable extends Component{
  constructor(props) {
    super(props);
    
    this.state = {
    };
    
    this.handleClick = this.handleClick.bind(this);
  }
  
  componentDidMount(){
    if (this.props.wos.length === 0){
      this.props.setWorkOrders();
    }
  }
  
  
  handleClick(event){
    let id = event.currentTarget.getAttribute("id");
    this.props.history.push("/services/" + id);
  }
  
  render(){
    return(
        <table className="cdb-small-table">
          <tbody>
          <tr>
            <th>Completed</th>
            <th>Service #</th>
            <th>Start</th>
            <th>Due</th>
            <th>Status</th>
            <th>Service Type</th>
            <th/>
          </tr>
          {this.props.wos.map((row) => {
              return(
                <tr key={row.id} style={{cursor: 'pointer'}}>
                  <td>{row.completed}</td>
                  <td>{row.workOrderNumber}</td>
                  <td>{row.start}</td>
                  <td>{row.due}</td>
                  <td>{row.status}</td>
                  <td>{row.serviceType}</td>
                  <td id={row.workOrderNumber} onClick={this.handleClick}><span className="breadcrumb-icon"/></td>
                </tr>
              );
            })}
          </tbody>
        </table>
        
    );
  };

}

const mapStateToProps = function(state) {
  return {
    wos: state.locationDetail.pastWOs,
  }
};

export default withRouter(connect(
  mapStateToProps,
  dispatch => bindActionCreators(actionCreators, dispatch)
)(WorkOrdersTable));